import React from 'react';
import { Card, Form } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWallet } from '@fortawesome/free-solid-svg-icons';

const PaymentSelector = ({
  paymentMethod,
  setPaymentMethod
}) => {
  return (
    <Card className="border-0 shadow-sm rounded-16 mt-3">
      <Card.Body className="p-3">
        <Form.Group>
          <Form.Label className="fw-bold text-muted small d-flex align-items-center gap-2">
            <FontAwesomeIcon icon={faWallet} style={{ color: '#0EABB0' }} />
            Método de Pago
          </Form.Label>
          <Form.Select
            value={paymentMethod}
            onChange={(e) => setPaymentMethod(e.target.value)}
            className="bg-light border-0 py-2 rounded-12 fw-bold"
            style={{ color: '#1E293B', cursor: 'pointer' }}
          >
            <option value="pago_movil">Pago Móvil</option>
            <option value="efectivo">Efectivo</option>
          </Form.Select>
        </Form.Group>
      </Card.Body>
    </Card>
  );
};

export default PaymentSelector;
